import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import React from 'react'
import ImagePreviewerDialog from './ImagePreviewerDialog';

const ImagePreviewer = ({value, width, height}: {value: any, width?: any, height?: any}) => {
    const [openImagePreviewerDialog, setOpenImagePreviewerDialog] = React.useState<boolean>(false);
    const [loaded, setLoaded] = React.useState(false);
    const [error, setError] = React.useState(false);

    const imgWidth = width ?? '120px';
    const imgHeight = height ?? '204px';

    return (
        <Box mr={2}>
            {value ? (
                <Box sx={{ position: 'relative', width: imgWidth, height: imgHeight }}>
                    {!loaded && !error && (
                        <Skeleton
                            variant="rectangular"
                            width={imgWidth}
                            height={imgHeight}
                            sx={{ borderRadius: 1, position: 'absolute', top: 0, left: 0 }}
                            animation="wave"
                        />
                    )}
                    {error ? (
                        <Box
                            sx={{
                                width: imgWidth,
                                height: imgHeight,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                bgcolor: 'action.hover',
                                borderRadius: 1,
                                fontSize: '0.75rem',
                                color: 'text.secondary',
                                textAlign: 'center',
                                p: 1,
                            }}
                        >
                            Image not available
                        </Box>
                    ) : (
                        <img
                            src={value}
                            style={{
                                width: imgWidth,
                                height: imgHeight,
                                objectFit: 'cover',
                                borderRadius: 4,
                                cursor: 'pointer',
                                display: loaded ? 'block' : 'none',
                            }}
                            alt="Cook"
                            onLoad={() => setLoaded(true)}
                            onError={() => { setError(true); setLoaded(true); }}
                            onClick={() => setOpenImagePreviewerDialog(true)}
                        />
                    )}
                    {openImagePreviewerDialog && (
                        <ImagePreviewerDialog
                            src={value}
                            open={openImagePreviewerDialog}
                            onClose={() => setOpenImagePreviewerDialog(false)}
                        />
                    )}
                </Box>
            ) : (
                <Box>Picture Not available</Box>
            )}
        </Box>
    );
};

export default ImagePreviewer;